import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "@tabler/core/dist/js/tabler.esm.min.js"

export default class extends Controller {
  connect() {
    this.tooltip = Tooltip.getOrCreateInstance(this.element, {
      delay: { show: 50, hide: 50 },
      placement: this.element.getAttribute("data-bs-placement") || "top"
    })
  }

  disconnect() {
    this.tooltip?.dispose()
  }
}
